require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-restrained-refinement-hornsby-residence-featured-on-the-local-project.json") })
        }
      }, "path---journal-restrained-refinement-hornsby-residence-featured-on-the-local-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-restrained-refinement-hornsby-residence-featured-on-the-local-project!./.cache/json/journal-restrained-refinement-hornsby-residence-featured-on-the-local-project.json
// module id = 530
// module chunks = 231608221292675